/**
 * Gerado por `tools/extrair-gesto-arma.mjs` a partir do legado (`BallList.xml` e `bomb/blastout/blastout<id>.swf`). Não edite à mão.
 * `GUN_BALLS`: bombas com `ActionType` 1 (o boneco saca a arma). As demais arremessam.
 * `WEAPON_MOTION`: o clipe `shootMovie<id>` (a arma na mão): nome do clipe no atlas, número de quadros e os quadros dos rótulos `shot` e `end` (`start` é sempre 1).
 */
export const GUN_BALLS: ReadonlySet<number> = new Set([4, 18, 19, 22, 23, 30, 31, 34, 42, 43, 45, 50, 51, 57, 58, 65, 72, 74, 75, 83, 84, 87, 96, 101, 102, 103, 104, 111, 112, 113, 114, 141, 142, 143, 144, 151, 152, 153, 154, 241, 242, 243, 251, 252, 253, 361, 362, 363, 364, 371, 372, 373, 374, 921, 922, 923, 924, 1011, 1012, 1021, 1022, 1031, 1032, 1041, 1042, 1411, 1412, 1421, 1422, 1431, 1432, 1441, 1442, 2411, 2412, 2421, 2422, 2431, 2432, 3611, 3612, 3621, 3622, 3631, 3632, 3641, 3642]);

export const WEAPON_MOTION: Readonly<Record<number, readonly [clip: string, frames: number, shot: number, end: number]>> = {
  1: ['blastOut1_fla.bindan1_4', 11, 4, 8],
  3: ['blastOut3_fla.chuansong1_5', 11, 4, 8],
  4: ['blastOut4_fla.daodan1_2', 10, 4, 8],
  6: ['blastOut6_fla._1_4', 11, 4, 8],
  7: ['blastOut7_fla._1_4', 11, 4, 8],
  8: ['blastOut8_fla._1_4', 11, 4, 8],
  9: ['blastOut9_fla._1_3', 11, 4, 8],
  10: ['blastOut10_fla._1_4', 11, 4, 8],
  18: ['blastOut18_fla._1_3', 10, 4, 8],
  19: ['blastOut19_fla._1_3', 10, 4, 8],
  20: ['blastOut20_fla._1_3', 11, 4, 8],
  21: ['blastOut21_fla._1_4', 11, 4, 8],
  22: ['blastOut22_fla._1_4', 10, 4, 8],
  23: ['blastOut23_fla._1_4', 10, 4, 8],
  26: ['blastOut26_fla._1_4', 11, 4, 8],
  27: ['blastOut27_fla._1_4', 11, 4, 8],
  28: ['blastOut28_fla._1_4', 11, 4, 8],
  29: ['blastOut29_fla._1_4', 11, 4, 8],
  30: ['blastOut30_fla._1_4', 10, 4, 8],
  31: ['blastOut31_fla._1_4', 10, 4, 8],
  32: ['blastOut32_fla._1_4', 11, 4, 8],
  33: ['blastOut33_fla._1_3', 11, 4, 8],
  34: ['blastOut34_fla._1_3', 10, 4, 8],
  35: ['blastOut35_fla._1_5', 11, 4, 8],
  36: ['blastOut36_fla._3_5', 12, 4, 9],
  37: ['blastOut37_fla._1_4', 12, 4, 9],
  38: ['blastOut38_fla._3_5', 12, 4, 9],
  42: ['blastOut42_fla._1_4', 10, 4, 8],
  43: ['blastOut43_fla._1_4', 10, 4, 8],
  44: ['blastOut44_fla._1_4', 10, 4, 8],
  45: ['blastOut45_fla._1_4', 10, 4, 8],
  50: ['blastOut50_fla._1_4', 10, 4, 8],
  51: ['blastOut51_fla._1_3', 10, 4, 8],
  59: ['blastOut59_fla._1_7', 11, 4, 8],
  62: ['blastOut62_fla._1_5', 11, 4, 8],
  63: ['blastOut63_fla._1_5', 11, 4, 8],
  64: ['blastOut64_fla._1_6', 11, 4, 8],
  68: ['blastOut68_fla._1_5', 11, 4, 8],
  74: ['blastOut74_fla._1_5', 10, 4, 8],
  75: ['blastOut75_fla._1_7', 10, 4, 8],
  76: ['blastOut76_fla._1_5', 10, 4, 8],
  77: ['blastOut77_fla._1_5', 10, 4, 8],
  78: ['blastOut78_fla.daodan1_2', 10, 4, 8],
  101: ['blastOut101_fla._1_5', 10, 4, 8],
  102: ['blastOut102_fla._2_5', 10, 4, 8],
  103: ['blastOut103_fla._3_5', 10, 4, 8],
  104: ['blastOut104_fla._4_5', 10, 4, 8],
  111: ['blastOut111_fla._1_5', 10, 4, 8],
  112: ['blastOut112_fla._2_5', 10, 4, 8],
  113: ['blastOut113_fla._3_5', 10, 4, 8],
  114: ['blastOut114_fla._4_5', 10, 4, 8],
  121: ['blastOut121_fla._1_5', 13, 4, 10],
  122: ['blastOut122_fla._2_3', 13, 4, 10],
  123: ['blastOut123_fla._3_3', 13, 4, 10],
  124: ['blastOut124_fla._4_4', 13, 4, 10],
  131: ['blastOut131_fla._1_3', 13, 4, 10],
  132: ['blastOut132_fla._2_3', 13, 4, 10],
  133: ['blastOut133_fla._3_4', 13, 4, 10],
  134: ['blastOut134_fla._4_2', 13, 4, 10],
  141: ['blastOut141_fla._1_4', 10, 4, 8],
  142: ['blastOut142_fla._2_4', 10, 4, 8],
  143: ['blastOut143_fla._3_4', 10, 4, 8],
  144: ['blastOut144_fla._4_4', 10, 4, 8],
  151: ['blastOut151_fla._1_4', 10, 4, 8],
  152: ['blastOut152_fla._2_4', 10, 4, 8],
  153: ['blastOut153_fla._3_4', 10, 4, 8],
  154: ['blastOut154_fla._4_4', 10, 4, 8],
  161: ['blastOut161_fla._1_5', 11, 4, 8],
  162: ['blastOut162_fla._2_5', 11, 4, 8],
  163: ['blastOut163_fla._3_5', 11, 4, 8],
  164: ['blastOut164_fla._4_5', 11, 4, 8],
  171: ['blastOut171_fla._1_5', 12, 4, 9],
  172: ['blastOut172_fla._2_5', 12, 4, 9],
  173: ['blastOut173_fla._3_5', 12, 4, 9],
  174: ['blastOut174_fla._4_5', 12, 4, 9],
  221: ['blastOut221_fla._1_5', 11, 4, 8],
  222: ['blastOut222_fla._1_5', 11, 4, 8],
  223: ['blastOut223_fla._1_5', 11, 4, 8],
  224: ['blastOut224_fla._1_5', 11, 4, 8],
  231: ['blastOut231_fla._1_5', 11, 4, 8],
  232: ['blastOut232_fla._1_5', 11, 4, 8],
  233: ['blastOut233_fla._1_5', 11, 4, 8],
  234: ['blastOut234_fla._1_5', 11, 4, 8],
  241: ['blastOut241_fla._1_5', 23, 4, 21],
  242: ['blastOut242_fla._1_5', 23, 4, 21],
  243: ['blastOut243_fla._1_5', 23, 4, 21],
  251: ['blastOut251_fla._1_5', 23, 4, 21],
  252: ['blastOut252_fla._1_5', 23, 4, 21],
  253: ['blastOut253_fla._1_5', 23, 4, 21],
  261: ['blastOut261_fla._1_5', 11, 4, 8],
  262: ['blastOut262_fla._1_5', 11, 4, 8],
  263: ['blastOut263_fla._1_5', 11, 4, 8],
  271: ['blastOut271_fla._1_5', 11, 4, 8],
  272: ['blastOut272_fla._1_5', 11, 4, 8],
  273: ['blastOut273_fla._1_5', 11, 4, 8],
  281: ['blastOut281_fla._1_3', 23, 4, 21],
  282: ['blastOut282_fla._1_3', 23, 4, 21],
  283: ['blastOut283_fla._1_3', 23, 4, 21],
  284: ['blastOut284_fla._1_3', 23, 4, 21],
  291: ['blastOut291_fla._1_3', 23, 4, 21],
  292: ['blastOut292_fla._1_3', 23, 4, 21],
  293: ['blastOut293_fla._1_3', 23, 4, 21],
  294: ['blastOut294_fla._1_3', 23, 4, 21],
  321: ['blastOut321_fla._1_5', 11, 4, 8],
  322: ['blastOut322_fla._2_5', 11, 4, 8],
  323: ['blastOut323_fla._3_5', 11, 4, 8],
  324: ['blastOut324_fla._4_5', 11, 4, 8],
  331: ['blastOut331_fla._1_5', 11, 4, 8],
  332: ['blastOut332_fla._2_5', 11, 4, 8],
  333: ['blastOut333_fla._3_5', 11, 4, 8],
  334: ['blastOut334_fla._4_5', 11, 4, 8],
  341: ['blastOut341_fla._1_5', 13, 4, 10],
  342: ['blastOut342_fla._2_5', 13, 4, 10],
  343: ['blastOut343_fla._3_5', 13, 4, 10],
  344: ['blastOut344_fla._4_5', 13, 4, 10],
  351: ['blastOut351_fla._1_4', 13, 4, 10],
  352: ['blastOut352_fla._1_4', 13, 4, 10],
  353: ['blastOut353_fla._1_4', 13, 4, 10],
  354: ['blastOut354_fla._1_4', 13, 4, 10],
  361: ['blastOut361_fla._1_5', 10, 4, 8],
  362: ['blastOut362_fla._2_5', 10, 4, 8],
  363: ['blastOut363_fla._3_5', 10, 4, 8],
  364: ['blastOut364_fla._4_5', 10, 4, 8],
  371: ['blastOut371_fla._1_5', 10, 4, 8],
  372: ['blastOut372_fla._2_5', 10, 4, 8],
  373: ['blastOut373_fla._3_5', 10, 4, 8],
  374: ['blastOut374_fla._4_5', 10, 4, 8],
  381: ['blastOut381_fla._1_5', 14, 4, 10],
  382: ['blastOut382_fla._2_5', 14, 4, 10],
  383: ['blastOut383_fla._3_5', 14, 4, 10],
  384: ['blastOut384_fla._4_5', 14, 4, 10],
  391: ['blastOut391_fla._1_5', 14, 4, 10],
  392: ['blastOut392_fla._2_5', 13, 4, 9],
  393: ['blastOut393_fla._3_5', 13, 4, 9],
  394: ['blastOut394_fla._4_5', 13, 4, 9],
  401: ['blastOut401_fla._1_5', 11, 4, 8],
  402: ['blastOut402_fla._2_5', 11, 4, 8],
  403: ['blastOut403_fla._3_5', 11, 4, 8],
  404: ['blastOut404_fla._4_5', 11, 4, 8],
  411: ['blastOut411_fla.Timeline_5', 11, 4, 8],
  412: ['blastOut412_fla.Timeline_5', 11, 4, 8],
  413: ['blastOut413_fla.Timeline_5', 11, 4, 8],
  414: ['blastOut414_fla.Timeline_5', 11, 4, 8],
  461: ['blastOut461_fla._1_5', 13, 4, 10],
  462: ['blastOut462_fla._2_5', 13, 4, 10],
  463: ['blastOut463_fla._3_5', 13, 4, 10],
  464: ['blastOut464_fla._4_5', 13, 4, 10],
  471: ['blastOut471_fla._1_5', 13, 4, 10],
  472: ['blastOut472_fla._2_5', 13, 4, 10],
  473: ['blastOut473_fla._3_5', 13, 4, 10],
  474: ['blastOut474_fla._4_5', 13, 4, 10],
  481: ['blastOut481_fla._1_5', 12, 4, 9],
  482: ['blastOut482_fla._2_5', 12, 4, 9],
  483: ['blastOut483_fla._3_5', 12, 4, 9],
  484: ['blastOut484_fla._4_5', 12, 4, 9],
  491: ['blastOut491_fla._1_5', 12, 4, 9],
  492: ['blastOut492_fla._2_5', 12, 4, 9],
  493: ['blastOut493_fla._3_5', 12, 4, 9],
  494: ['blastOut494_fla._4_5', 12, 4, 9],
  661: ['blastOut661_fla._1_5', 12, 4, 9],
  662: ['blastOut662_fla._2_5', 12, 4, 9],
  663: ['blastOut663_fla._3_5', 12, 4, 9],
  664: ['blastOut664_fla._4_5', 12, 4, 9],
  671: ['blastOut671_fla._1_5', 12, 4, 9],
  672: ['blastOut672_fla._2_5', 12, 4, 9],
  673: ['blastOut673_fla._3_5', 12, 4, 9],
  674: ['blastOut674_fla._4_5', 12, 4, 9],
  701: ['blastOut701_fla._1_5', 12, 4, 9],
  702: ['blastOut702_fla._2_5', 12, 4, 9],
  703: ['blastOut703_fla._3_5', 12, 4, 9],
  704: ['blastOut704_fla._4_5', 12, 4, 9],
  711: ['blastOut711_fla._1_5', 12, 4, 9],
  712: ['blastOut712_fla._2_5', 12, 4, 9],
  713: ['blastOut713_fla._3_5', 12, 4, 9],
  714: ['blastOut714_fla._4_5', 12, 4, 9],
  881: ['blastOut881_fla._1_5', 11, 4, 8],
  882: ['blastOut882_fla._2_5', 11, 4, 8],
  883: ['blastOut883_fla._3_5', 11, 4, 8],
  884: ['blastOut884_fla._4_5', 11, 4, 8],
  891: ['blastOut891_fla._1_5', 11, 4, 8],
  901: ['blastOut901_fla.Timeline_5', 11, 4, 8],
  902: ['blastOut902_fla._2_5', 11, 4, 8],
  903: ['blastOut903_fla._3_4', 11, 4, 8],
  904: ['blastOut904_fla._4_4', 11, 4, 8],
  911: ['blastOut911_fla._1_5', 11, 4, 8],
  912: ['blastOut912_fla._2_5', 11, 4, 8],
  913: ['blastOut913_fla._3_5', 11, 4, 8],
  914: ['blastOut914_fla._4_5', 11, 4, 8],
  921: ['blastOut921_fla._1_5', 11, 4, 8],
  922: ['blastOut922_fla._2_4', 11, 4, 8],
  923: ['blastOut923_fla._3_5', 11, 4, 8],
  924: ['blastOut924_fla._4_5', 11, 4, 8],
  931: ['blastOut931_fla._1_5', 11, 4, 8],
  932: ['blastOut932_fla._2_5', 11, 4, 8],
  933: ['blastOut933_fla._3_5', 11, 4, 8],
  934: ['blastOut934_fla._4_5', 11, 4, 8],
  941: ['blastOut941_fla._1_5', 11, 4, 8],
  942: ['blastOut942_fla._2_5', 11, 4, 8],
  943: ['blastOut943_fla._3_5', 11, 4, 8],
  944: ['blastOut944_fla._4_5', 11, 4, 8],
  951: ['blastOut951_fla._1_5', 11, 4, 8],
  952: ['blastOut952_fla._2_5', 11, 4, 8],
  953: ['blastOut953_fla._3_5', 11, 4, 8],
  954: ['blastOut954_fla._4_5', 11, 4, 8],
  971: ['blastOut971_fla._1_5', 11, 4, 8],
  972: ['blastOut972_fla._2_5', 11, 4, 8],
  973: ['blastOut973_fla._3_5', 11, 4, 8],
  974: ['blastOut974_fla._4_5', 11, 4, 8],
  1011: ['blastOut1011_fla._1_3', 10, 4, 8],
  1012: ['blastOut1012_fla._1_5', 10, 4, 8],
  1021: ['blastOut1021_fla._1_3', 10, 4, 8],
  1022: ['blastOut1022_fla._1_5', 10, 4, 8],
  1031: ['blastOut1031_fla._1_4', 10, 4, 8],
  1032: ['blastOut1032_fla._1_5', 10, 4, 8],
  1041: ['blastOut1041_fla._1_4', 10, 4, 8],
  1042: ['blastOut1042_fla._1_5', 10, 4, 8],
  1211: ['blastOut1211_fla._1_3', 13, 4, 10],
  1212: ['blastOut1212_fla._1_3', 13, 4, 10],
  1221: ['blastOut1221_fla._1_3', 13, 4, 10],
  1222: ['blastOut1222_fla._1_3', 13, 4, 10],
  1231: ['blastOut1231_fla._1_3', 13, 4, 10],
  1232: ['blastOut1232_fla._1_4', 13, 4, 10],
  1241: ['blastOut1241_fla._1_3', 13, 4, 10],
  1242: ['blastOut1242_fla._1_4', 13, 4, 10],
  1411: ['blastOut1411_fla._1_4', 10, 4, 8],
  1412: ['blastOut1412_fla._1_4', 10, 4, 8],
  1421: ['blastOut1421_fla._2_4', 10, 4, 8],
  1422: ['blastOut1422_fla._2_4', 10, 4, 8],
  1431: ['blastOut1431_fla._3_4', 10, 4, 8],
  1432: ['blastOut1432_fla._3_4', 10, 4, 8],
  1441: ['blastOut1441_fla._4_4', 10, 4, 8],
  1442: ['blastOut1442_fla._4_4', 10, 4, 8],
  1611: ['blastOut1611_fla._1_4', 11, 4, 8],
  1612: ['blastOut1612_fla._1_4', 11, 4, 8],
  1621: ['blastOut1621_fla._1_5', 11, 4, 8],
  1622: ['blastOut1622_fla._1_4', 11, 4, 8],
  1631: ['blastOut1631_fla._1_5', 11, 4, 8],
  1632: ['blastOut1632_fla._1_4', 11, 4, 8],
  1641: ['blastOut1641_fla._1_5', 11, 4, 8],
  1642: ['blastOut1642_fla._1_4', 11, 4, 8],
  2211: ['blastOut2211_fla._1_5', 11, 4, 8],
  2212: ['blastOut2212_fla._1_5', 11, 4, 8],
  2221: ['blastOut2221_fla._1_5', 11, 4, 8],
  2222: ['blastOut2222_fla._1_5', 11, 4, 8],
  2231: ['blastOut2231_fla._1_5', 11, 4, 8],
  2232: ['blastOut2232_fla._1_5', 11, 4, 8],
  2241: ['blastOut2241_fla._1_5', 11, 4, 8],
  2242: ['blastOut2242_fla._1_5', 11, 4, 8],
  2411: ['blastOut2411_fla._1_5', 23, 4, 21],
  2412: ['blastOut2412_fla._1_5', 23, 4, 21],
  2421: ['blastOut2421_fla._1_5', 23, 4, 21],
  2422: ['blastOut2422_fla._1_5', 23, 4, 21],
  2431: ['blastOut2431_fla._1_5', 23, 4, 21],
  2432: ['blastOut2432_fla._1_5', 23, 4, 21],
  2611: ['blastOut2611_fla._1_5', 11, 4, 8],
  2612: ['blastOut2612_fla._1_6', 11, 4, 8],
  2621: ['blastOut2621_fla._1_5', 11, 4, 8],
  2622: ['blastOut2622_fla._1_6', 11, 4, 8],
  2631: ['blastOut2631_fla._1_5', 11, 4, 8],
  2632: ['blastOut2632_fla._1_5', 11, 4, 8],
  2811: ['blastOut2811_fla._1_3', 23, 4, 21],
  2812: ['blastOut2812_fla._1_3', 23, 4, 21],
  2821: ['blastOut2821_fla._1_3', 23, 4, 21],
  2822: ['blastOut2822_fla._1_3', 23, 4, 21],
  2831: ['blastOut2831_fla._1_3', 23, 4, 21],
  2832: ['blastOut2832_fla._1_3', 23, 4, 21],
  2841: ['blastOut2841_fla._1_3', 23, 4, 21],
  2842: ['blastOut2842_fla._1_3', 23, 4, 21],
  3211: ['blastOut3211_fla._1_3', 11, 4, 8],
  3212: ['blastOut3212_fla._1_4', 11, 4, 8],
  3221: ['blastOut3221_fla._1_3', 11, 4, 8],
  3222: ['blastOut3222_fla._1_4', 11, 4, 8],
  3231: ['blastOut3231_fla._1_4', 11, 4, 8],
  3232: ['blastOut3232_fla._1_4', 11, 4, 8],
  3241: ['blastOut3241_fla._1_4', 11, 4, 8],
  3242: ['blastOut3242_fla._1_4', 11, 4, 8],
  3411: ['blastOut3411_fla._1_3', 13, 4, 10],
  3412: ['blastOut3412_fla._1_3', 13, 4, 10],
  3421: ['blastOut3421_fla._1_3', 13, 4, 10],
  3422: ['blastOut3422_fla._1_3', 13, 4, 10],
  3431: ['blastOut3431_fla._1_4', 13, 4, 10],
  3432: ['blastOut3432_fla._1_3', 13, 4, 10],
  3441: ['blastOut3441_fla._1_4', 13, 4, 10],
  3442: ['blastOut3442_fla._1_4', 13, 4, 10],
  3611: ['blastOut3611_fla._1_3', 10, 4, 8],
  3612: ['blastOut3612_fla._1_5', 10, 4, 8],
  3621: ['blastOut3621_fla._1_3', 10, 4, 8],
  3622: ['blastOut3622_fla._1_5', 10, 4, 8],
  3631: ['blastOut3631_fla._3_4', 10, 4, 8],
  3632: ['blastOut3632_fla._3_5', 10, 4, 8],
  3641: ['blastOut3641_fla._3_5', 10, 4, 8],
  3642: ['blastOut3642_fla._3_5', 10, 4, 8],
  3811: ['blastOut3811_fla._1_3', 11, 4, 8],
  3812: ['blastOut3812_fla._1_3', 11, 4, 8],
  3821: ['blastOut3821_fla._1_3', 11, 4, 8],
  3822: ['blastOut3822_fla._1_3', 11, 4, 8],
  3831: ['blastOut3831_fla._1_4', 11, 4, 8],
  3832: ['blastOut3832_fla._1_3', 11, 4, 8],
  3841: ['blastOut3841_fla._1_4', 11, 4, 8],
  3842: ['blastOut3842_fla._1_4', 11, 4, 8],
  4011: ['blastOut4011_fla._1_5', 11, 4, 8],
  4012: ['blastOut4012_fla._1_3', 11, 4, 8],
  4021: ['blastOut4021_fla._1_3', 11, 4, 8],
  4022: ['blastOut4022_fla._1_5', 11, 4, 8],
  4031: ['blastOut4031_fla._1_4', 11, 4, 8],
  4032: ['blastOut4032_fla._1_5', 11, 4, 8],
  4041: ['blastOut4041_fla._1_4', 11, 4, 8],
  4042: ['blastOut4042_fla._1_4', 11, 4, 8],
  4611: ['blastOut4611_fla._1_5', 13, 4, 10],
  4612: ['blastOut4612_fla._1_5', 13, 4, 10],
  4621: ['blastOut4621_fla._1_4', 13, 4, 10],
  4622: ['blastOut4622_fla._1_4', 13, 4, 10],
  4631: ['blastOut4631_fla._1_4', 13, 4, 10],
  4632: ['blastOut4632_fla._1_4', 13, 4, 10],
  4641: ['blastOut4641_fla._1_3', 13, 4, 10],
  4642: ['blastOut4642_fla._1_4', 13, 4, 10],
  4811: ['blastOut4811_fla._1_5', 12, 4, 9],
  4812: ['blastOut4812_fla._1_4', 12, 4, 9],
  4821: ['blastOut4821_fla._1_5', 12, 4, 9],
  4822: ['blastOut4822_fla._1_5', 12, 4, 9],
  4831: ['blastOut4831_fla._1_5', 12, 4, 9],
  4832: ['blastOut4832_fla._1_4', 12, 4, 9],
  4841: ['blastOut4841_fla._1_4', 12, 4, 9],
  4842: ['blastOut4842_fla._1_4', 12, 4, 9],
  6611: ['blastOut6611_fla._1_5', 12, 4, 9],
  6612: ['blastOut6612_fla._2_5', 12, 4, 9],
  6621: ['blastOut6621_fla._1_5', 12, 4, 9],
  6622: ['blastOut6622_fla._2_5', 12, 4, 9],
  6631: ['blastOut6631_fla._1_4', 12, 4, 9],
  6632: ['blastOut6632_fla._1_5', 12, 4, 9],
  6641: ['blastOut6641_fla._1_4', 12, 4, 9],
  6642: ['blastOut6642_fla._1_5', 12, 4, 9],
  7011: ['blastOut7011_fla._1_3', 12, 4, 9],
  7012: ['blastOut7012_fla._1_3', 12, 4, 9],
  7021: ['blastOut7021_fla._2_5', 12, 4, 9],
  7022: ['blastOut7022_fla._2_5', 12, 4, 9],
  7031: ['blastOut7031_fla._3_5', 12, 4, 9],
  7032: ['blastOut7032_fla._3_5', 12, 4, 9],
  7041: ['blastOut7041_fla._4_5', 12, 4, 9],
  7042: ['blastOut7042_fla._4_5', 12, 4, 9],
};
